import { __assign } from "tslib";
// 流程跟踪
import { getUuid } from '../utils';
import { commonClickWeblogger } from '../weblog';
var DEFAULT = {
    type: '',
    enterTime: 0,
    leaveTime: 0,
    duration: 0,
    userName: '',
    traceId: '',
    stepData: {},
    stepTotalTime: 0, // 用于对比duration的准确性
};
var loggerData = __assign({}, DEFAULT);
// 步骤
var stepData = {};
var prevData = null;
export function sendWebloggerProcess(type, stepNumber, params) {
    var now = Date.now();
    loggerData.type = type;
    loggerData.stepData = stepData;
    // 目前默认enter就是step = 1；
    if (type === 'enter') {
        loggerData.enterTime = now;
        loggerData.traceId = getUuid();
        loggerData.userName = (params === null || params === void 0 ? void 0 : params.userName) || '';
        sendWeblogger();
    }
    var typeValue = type;
    // step为number，但type为非number
    if (typeof stepNumber === 'number' && typeof type !== 'number') {
        typeValue = stepNumber;
    }
    // 如果是step，下一步则 type++
    if (typeof typeValue === 'number') {
        setStepData(typeValue);
    }
    if (type === 'leave' || type === 'submit') {
        loggerData.leaveTime = now;
        loggerData.duration = now - loggerData.enterTime;
        if (prevData) {
            setPrevStepItem(now);
        }
        Object.keys(stepData).forEach(function (key) {
            var item = stepData[+key];
            loggerData.stepTotalTime += item.duration;
        });
        sendWeblogger();
        // clear data
        if (type === 'leave' || type === 'submit') {
            loggerData = __assign({}, DEFAULT);
            stepData = {};
            prevData = null;
        }
    }
}
function sendWeblogger() {
    commonClickWeblogger('PROCESS_GENERAL', {
        pathname: window.location.pathname,
        params: loggerData,
    });
}
function setPrevStepItem(now) {
    prevData.duration += now - prevData.timestamp;
}
function setStepData(type) {
    var now = Date.now();
    // 初始化值
    if (!stepData[type]) {
        stepData[type] = {
            duration: 0,
            timestamp: now,
            type: type,
        };
    }
    // 存储前值
    if (!prevData) {
        prevData = stepData[type];
    }
    // type不一致，表示进行的流程切换
    // 需要对前值进行更新
    if (prevData.type !== stepData[type].type) {
        stepData[type].timestamp = now;
        setPrevStepItem(now);
        prevData = stepData[type];
    }
}
